'use strict';
import {react2angular} from "react2angular";
import DashboardPurchaseOrdersWrapper from "../../src/views/dashboard-purchase-orders/DashboardPurchaseOrdersWrapper";

angular
  .module('dstreamApp.reactBridge')
  .component('dsDashboardPurchaseOrders', react2angular(DashboardPurchaseOrdersWrapper));
